import { FC } from 'react';

import { Box, Flex, Radio, Text } from '@bonusly/design-system';

import { VisibilityOption } from './hooks/use-privacy';

interface PrivacyOptionProps {
	option: VisibilityOption;
	onChange: VoidFunction;
}

export const PrivacyOption: FC<PrivacyOptionProps> = ({ option, onChange }) => {
	return (
		<Radio
			borderColor="gray.250"
			justifyContent="space-between"
			onChange={onChange}
			pb={3.5}
			pl={5}
			pr={8}
			pt={3.5}
			spacing={0}
			value={option.value}
			sx={{
				order: 1,
				width: 6,
				height: 6,
				borderColor: 'gray.250',
			}}
		>
			<Flex>
				<Box alignItems="center" bg="gray.50" borderRadius="50%" display="flex" flexShrink={0} height={10} justifyContent="center" width={10}>
					{option.icon}
				</Box>

				<Box ml={3}>
					<Text fontSize="xl" fontWeight="md">
						{option.label}
					</Text>
					<Text fontSize="sm" fontWeight={400}>
						{option.description}
					</Text>
				</Box>
			</Flex>
		</Radio>
	);
};
